import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";
import { MazeScene } from "./scenes/maze-scene/MazeScene";
import { MazeManager } from "./scenes/maze-scene/MazeManager";
import { MazeContainer } from "./scenes/maze-scene/MazeContainer";
import { AudioManager } from "./AudioManager";

export class GameManager {

    public static init(): void { 
        
        GameVars.languages = GameVars.currentScene.cache.json.get("languages");

        GameManager.readGameData();
    }

    public static readGameData(): void {

        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            function (gameData: string): void {

                if (gameData) {
                    GameVars.gameData = JSON.parse(gameData);
                } else {
                    GameVars.gameData = {
                        muted: false,
                        highScore: 0,
                        language: GameConstants.LANGUAGE_EN
                    };
                }

                GameManager.startGame();
            }
        );
    }

    public static setCurrentScene(scene: Phaser.Scene): void {

        GameVars.currentScene = scene;
    }

    public static onMazeSolved(): void {

        const goalState = MazeContainer.currentInstance.goal.currentState;

        if (goalState === GameConstants.GOAL_POINTS) {
            GameVars.score += GameConstants.PASSED_LEVEL_EXTRA_POINTS;
        } else if (goalState === GameConstants.GOAL_TIME) {
            GameVars.time += GameConstants.PASSED_LEVEL_EXTRA_TIME;
        }

        MazeScene.currentInstance.mazeSolved();

        MazeScene.currentInstance.showTransitionLayer(() => {

            GameVars.currentLevel++;
            GameVars.levelColourId = (GameVars.levelColourId + 1) % 5;

            GameManager.newLevel();
        });
    }

    public static newLevel(): void {

        MazeManager.newLevel();
    }

    public static gameOver(): void {

        if (GameVars.score >= GameVars.gameData.highScore) {

            GameVars.gameData.highScore = GameVars.score;
            GameManager.writeGameData();
        }

        MazeScene.currentInstance.gameOver();
    }

    public static enterMazeScene(): void {

        GameVars.score = 0;
        GameVars.time = GameConstants.START_TIME;
        GameVars.gameOver = false;
        GameVars.path = [];
        GameVars.pause = false;
        GameVars.currentLevel = 1;
        GameVars.levelColourId = 0;

        GameVars.currentScene.scene.start("MazeScene");
    }

    public static onGameAssetsLoaded(): void {

        AudioManager.init();

        GameManager.enterSplash();
        // GameManager.enterMazeScene();
    }

    public static enterSplash(): void {

        GameVars.pause = false;

        GameVars.currentScene.scene.start("SplashScene");
    }

    public static writeGameData(): void {

        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            GameVars.gameData,
            function (): void {
                GameManager.log("game data successfully saved");
            }
        );
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    private static startGame(): void {

        GameVars.currentScene.scene.start("PreloadScene");
    }

    private static getGameStorageData(key: string, successCb: Function): void {

        const gameDataStr = localStorage.getItem(key);
        successCb(gameDataStr);
    }

    private static setGameStorageData(key: string, value: any, successCb: Function): void {

        localStorage.setItem(key, JSON.stringify(value));
        successCb();
    }
}
